<template>
  <div class="step-progressbar">
    <span
      v-for="stepIndex in totalSteps + 1"
      :key="stepIndex"
      class="step-progressbar__step"
      :class="[
        currentStepIndex + 1 >= stepIndex
          ? 'step-progressbar__step--enabled'
          : '',
        currentStepIndex + 1 == stepIndex
          ? 'step-progressbar__step--current'
          : ''
      ]"
    ></span>
  </div>
</template>

<script>
export default {
  computed: {
    currentStepIndex() {
      return this.$store.getters.currentStepIndex;
    },
    totalSteps() {
      return this.$store.getters.totalSteps;
    }
  }
};
</script>

<style lang="scss" scoped>
.step-progressbar {
  display: flex;
  margin: 0 -3px;

  &__step {
    position: relative;
    flex: 1 1 auto;
    height: 8px;
    background: #dfdfdf;
    margin: 0 3px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: scaleX(0);
      will-change: transform;
      background: #ff866e;
      transition: transform 0.6s ease-in-out;
      transform-origin: 0 0;
    }

    &--enabled {
      &::before {
        transform: scaleX(1);
      }
    }
  }
}
</style>
